import { render, staticRenderFns } from "./collaboration-project-info.html?vue&type=template&id=7854f2ec&scoped=true&external"
import script from "./collaboration-project-info.js?vue&type=script&lang=js&external"
export * from "./collaboration-project-info.js?vue&type=script&lang=js&external"
import style0 from "./collaboration-project-info.scss?vue&type=style&index=0&id=7854f2ec&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7854f2ec",
  null
  
)

export default component.exports